import { CrunchServiceWithContext, CrunchAccountServiceWithContext } from "@crunchdao/sdk";
import { EnhancedBaseCommand } from "@crunchdao/shared-cli";

export class CreateCommand extends EnhancedBaseCommand {
  async execute(name: string, payoutAmount: string, maxModelsPerCruncher: string): Promise<void> {
    const crunchService = CrunchServiceWithContext({
      program: this.program,
    });

    const crunchAccountService = CrunchAccountServiceWithContext({
      program: this.program,
    });

    const crunchData = {
      name,
      payoutAmount: parseInt(payoutAmount) || 10,
      maxModelsPerCruncher: parseInt(maxModelsPerCruncher) || 2,
    };

    try {
      await this.executeOrProposeInstructions(async () => {
        return [await crunchService.createCrunchInstruction(crunchData, this.getSigner())];
      }, `Create crunch "${name}" (payout: ${crunchData.payoutAmount} USDC, max models: ${crunchData.maxModelsPerCruncher})`);

      if (!this.isMultisigMode()) {
        const crunchAddress = crunchAccountService.getCrunchAddress(name);

        this.success("Crunch created successfully", {
          crunchName: name,
          crunchAddress: crunchAddress.toBase58(),
          payoutAmount: crunchData.payoutAmount,
          maxModelsPerCruncher: crunchData.maxModelsPerCruncher,
        });
      }
    } catch (error) {
      this.handleCreateError(error, name);
    }
  }

  private handleCreateError(error: any, crunchName: string): never {
    // Check for crunch already exists error
    if (
      error.transactionLogs &&
      error.transactionLogs.some(
        (log: string) => log.includes("already in use") && log.includes("Allocate: account Address")
      )
    ) {
      // Extract the crunch address from the transaction logs
      const addressMatch = error.transactionLogs
        .find((log: string) => log.includes("already in use"))
        ?.match(/address: ([A-Za-z0-9]{32,44})/);
      const crunchAddress = addressMatch ? addressMatch[1] : "unknown";

      const customError = this.createEnhancedError(
        `Crunch "${crunchName}" already exists at address ${crunchAddress}`,
        "CrunchAlreadyExistsError",
        "CRUNCH_ALREADY_EXISTS",
        {
          crunchName,
          crunchAddress,
          suggestion: "Use a different name or start the existing crunch",
        },
        error
      );

      return this.handleError(customError);
    }

    // Fall back to generic transaction error handling
    return this.handleTransactionError(error, crunchName);
  }
}
